/* ============================================================
   Рендер динамических блоков: услуги, «почему мы», шаги,
   каналы связи (в блоке контактов и в поповере).
   Перерисовывается при каждой смене языка.
   ============================================================ */
import { onLangChange } from '../i18n';
import { svg, ICON } from '../icons';
import { SERVICE_ICONS } from '../data';
import { CHANNELS } from '../config';
import { byId } from '../dom';
import type { Dictionary } from '../types';

function channelsHtml(forPopover: boolean): string {
  return CHANNELS.map((c) => {
    const ext = c.href.startsWith('http') ? ' target="_blank" rel="noopener"' : '';
    if (forPopover) {
      return (
        `<a class="pop-item" href="${c.href}"${ext} role="menuitem">` +
        `<span class="pi">${svg(c.icon, c.filled)}</span>` +
        `<span><span class="pt">${c.title}</span><span class="ps">${c.subtitle}</span></span>` +
        `<span class="arr">${svg(ICON.arr)}</span></a>`
      );
    }
    return (
      `<a class="chan" href="${c.href}"${ext}>${svg(c.icon, c.filled)}` +
      `<div>${c.title}<small>${c.subtitle}</small></div></a>`
    );
  }).join('');
}

// Первый рендер — карточки появляются с анимацией (класс reveal без in),
// последующие (смена языка) — сразу видимы (reveal in).
let firstRender = true;

function renderContent(dict: Dictionary): void {
  const cls = firstRender ? 'reveal' : 'reveal in';

  byId('svcGrid').innerHTML = dict.services
    .map(
      (s, i) =>
        `<a class="svc ${cls}" style="transition-delay:${(i % 3) * 70}ms" href="#contact" data-form="${i}">` +
        `<div class="ic">${svg(SERVICE_ICONS[i])}</div>` +
        `<h3>${s[0]}</h3><p>${s[1]}</p>` +
        `<div class="go">${dict.order} →</div></a>`,
    )
    .join('');

  byId('whyGrid').innerHTML = dict.why
    .map(
      (w, i) =>
        `<div class="why-card ${cls}" style="transition-delay:${(i % 2) * 80}ms">` +
        `<div class="k">${w[0]}</div><h3>${w[1]}</h3><p>${w[2]}</p></div>`,
    )
    .join('');

  byId('steps').innerHTML = dict.steps
    .map(
      (s, i) =>
        `<div class="step ${cls}" style="transition-delay:${i * 70}ms">` +
        `<div class="sn">${s[0]}</div><h3>${s[1]}</h3><p>${s[2]}</p></div>`,
    )
    .join('');

  byId('channels').innerHTML = channelsHtml(false);
  byId('popList').innerHTML = channelsHtml(true);

  firstRender = false;
}

/** Подписать рендер на смену языка. */
export function initRender(): void {
  onLangChange(renderContent);
}
